module.exports = __webpack_public_path__ + "static/img/gfo-logo.12f4115.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/content-layout/assets/img/gfo-logo.png
// module id = ymA/
// module chunks = 95